import loadable from "@loadable/component";

import { useSharedGlobalConfig } from "@shared/hooks";
import { isProduction } from "@shared/utils";
const ExperimentTester = loadable(
  () => import(/* webpackChunkName: "development-experiment-tester" */ "../ExperimentTester"),
  {
    fallback: null,
  }
);

const LazyExperimentTester = () => {
  const { isAdminImpersonating } = useSharedGlobalConfig();

  if (isProduction() && !isAdminImpersonating) return null;

  return <ExperimentTester />;
};

export { LazyExperimentTester };
